import { trainingHistoryApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';
import { TrainingHistoryEntry, UpdateHistoryEntry } from '@/generated';

const invalidateTrainingHistory = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: [queryKeys.TrainingHistory] });
  queryClient.invalidateQueries({ queryKey: [queryKeys.TrainingHistoryByUser] });
};

export const useDeleteTrainingHistoryEntry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (entryId: string) => trainingHistoryApi.trainingHistoryDeleteEntry({ entryId }),
    onSuccess: () => {
      invalidateTrainingHistory(queryClient);
    },
  });
};

export const useUpdateTrainingHistoryEntry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (trainingHistoryEntry: TrainingHistoryEntry) => {
      const updateHistoryEntry: UpdateHistoryEntry = {
        entryId: trainingHistoryEntry.entryId,
        completionTime: trainingHistoryEntry.completionTime,
        trainingEntry: trainingHistoryEntry.completedTraining,
      };

      return trainingHistoryApi.trainingHistoryUpdate({ updateHistoryEntry });
    },
    onSuccess: () => {
      invalidateTrainingHistory(queryClient);
    },
  });
};
